import { useNavigate } from 'react-router-dom';
import { SimpleNavbar } from '../../components/layout/SimpleNavbar';
import { AuthButton } from '../../components/common/AuthButton';

export const ProfileApprovedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-common-gradient">
      <SimpleNavbar />

      <div className="flex items-center justify-center min-h-screen px-4">
        <div className="max-w-2xl w-full text-center">

          {/* Pending Icon */}
          <div className="flex justify-center mb-8">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-cyan-400/20 to-blue-500/20 border-2 border-cyan-400/50 flex items-center justify-center">
              <svg className="w-10 h-10 text-cyan-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
          </div>

          {/* Main Heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-anton text-white mb-6 leading-tight">
            PROFILE SUBMITTED SUCCESSFULLY!
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl font-inter font-semibold text-cyan-400 mb-8">
            You're almost there
          </p>

          {/* Steps / Info */}
          <div className="rounded-2xl bg-slate-800/50 backdrop-blur-md border border-slate-700/50 p-6 sm:p-8 mb-10 text-left space-y-5">

            <div className="flex items-start gap-4">
              <div className="w-8 h-8 rounded-lg bg-cyan-400/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-cyan-400 text-sm font-bold">1</span>
              </div>
              <div>
                <p className="text-white text-sm font-semibold">Your profile is under review</p>
                <p className="text-gray-400 text-xs mt-1">
                  Your profile has been sent to our admin team for verification. This usually takes a short time — we'll review it as quickly as possible.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-8 h-8 rounded-lg bg-cyan-400/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-cyan-400 text-sm font-bold">2</span>
              </div>
              <div>
                <p className="text-white text-sm font-semibold">You'll receive your password via email</p>
                <p className="text-gray-400 text-xs mt-1">
                  Once approved, we'll send your login password to your registered email address. Please keep an eye on your inbox (and spam folder).
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-8 h-8 rounded-lg bg-cyan-400/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-cyan-400 text-sm font-bold">3</span>
              </div>
              <div>
                <p className="text-white text-sm font-semibold">Log in and get started</p>
                <p className="text-gray-400 text-xs mt-1">
                  Use your email and the password from the email to log in. Once signed in, you can view your stats, update your profile, and connect with coaches and scouts.
                </p>
              </div>
            </div>
          </div>

          {/* Login Button */}
          <AuthButton onClick={() => navigate('/auth/login')}>
            GO TO LOGIN
          </AuthButton>

          {/* <p className="text-gray-500 text-xs mt-6">
            Have questions? Contact <a href="mailto:support@jucopipeline.com" className="text-cyan-400 hover:underline">support@jucopipeline.com</a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default ProfileApprovedPage;
